import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React, { VFC } from 'react';
import { useIntl } from 'react-intl';

import { Description } from './Description';
import { SettingTitle } from './SettingTitle';

import { LANGUAGES } from '../constants';
import { HandleSettingChange, Message, SettingKey } from '../types';

const useStyles = makeStyles(theme => ({
  setting: {
    margin: theme.spacing(2, 0, 0, 0),
  },
  select: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

export interface LanguageSelectorProps {
  settingKey: SettingKey;
  title: Message;
  description: Message;
  placeholder: Message;
  selectedLanguage?: string;
  onChange: HandleSettingChange;
  className?: string;
  disabled?: boolean;
}

export const LanguageSelector: VFC<LanguageSelectorProps> = ({
  settingKey,
  title,
  description,
  placeholder,
  selectedLanguage,
  onChange,
  className,
  disabled,
}) => {
  const styles = useStyles();
  const intl = useIntl();

  const handleLanguageChange = (selected: { key: string; label: string }) => {
    onChange(settingKey, selected.key);
  };

  return (
    <div className={classnames(styles.setting, className)}>
      <SettingTitle value={title} />
      <Description value={description} />
      <div className={styles.select}>
        <StyledReactSelect
          options={LANGUAGES}
          value={
            LANGUAGES.find(lang => lang.key === selectedLanguage) ??
            LANGUAGES.find(lang => lang.key === 'en')
          }
          onChange={handleLanguageChange}
          placeholder={intl.formatMessage(placeholder)}
          getOptionLabel={(language: { label: string }) => language.label}
          getOptionValue={(language: { key: string }) => language.key}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};
